import { Link } from '@tanstack/react-router'
import { useTranslation } from 'react-i18next'

import { buttonVariants } from '@/shared/ui/button'

export function NotFound() {
  const { t } = useTranslation()

  return (
    <div className="flex min-h-[60svh] flex-col items-center justify-center gap-4 p-8 text-center">
      <p className="font-display text-6xl font-bold text-muted-foreground tabular-nums">404</p>
      <p className="text-lg">{t('app.notFound')}</p>
      <Link to="/" className={buttonVariants({ variant: 'outline' })}>
        {t('app.backHome')}
      </Link>
    </div>
  )
}
